import React from 'react';
import { StarIcon } from '@heroicons/react/24/solid';
import { useLanguage } from '../contexts/LanguageContext';

interface GoogleReviewsProps {
  className?: string;
  showText?: boolean;
  variant?: 'light' | 'dark';
}

const GoogleReviews: React.FC<GoogleReviewsProps> = ({ 
  className = "", 
  showText = true,
  variant = 'light' 
}) => {
  const { translations } = useLanguage();
  const reviews = translations.header.reviews;

  if (!reviews) return null;

  const ratingColor = variant === 'light' ? 'text-white' : 'text-navy';
  const countColor = variant === 'light' ? 'text-white/80' : 'text-gray-600';
  const googleColor = variant === 'light' ? 'text-white/60' : 'text-gray-400';

  return (
    <a 
      href="https://www.google.com/search?sca_esv=e4930b54a8b6c4ed&q=SeaDent+Mallorca+reviews&si=AL3DRZEsmMGCryMMFSHJ3StBhOdZ2-6yYkXd_doETEE1OR-qObVJybdlJSfmnd0Uw9-mAsO6_ktA_aCZUPgBCG0iNC2sA0rBcPjidQsC5ABDG1bFxhcGcbs%3D&uds=ALYpb_kG5vW-vCilX_Rbjx0DZ5HJ2iToYbUq5jS1JCACXimMsJbBLCEmzrH2vbprC06zDU7cVCLnlRUiq6jS4y_mH67N7TlTkkqMTi0SJJcJA9hFyvs836_uZMS7NSUP8OAEL5_0xGWP&sa=X&ved=2ahUKEwjr4NeE1ZCSAxWFgP0HHYftOQgQ3PALegQIMBAF&biw=2048&bih=1017&dpr=1.25&aic=0" 
      target="_blank" 
      rel="noopener noreferrer"
      className={`flex items-center space-x-1 group hover:opacity-80 transition-opacity ${className}`}
      aria-label={`${reviews.rating} stars on Google from ${reviews.count}`}
    >
      <div className="flex items-center mr-1">
        {[...Array(5)].map((_, i) => (
          <StarIcon key={i} className="w-4 h-4 text-[#FBBC04]" /> // Google Star Gold color
        ))}
      </div>
      {showText && (
        <div className="flex items-center space-x-1.5 leading-none">
          <span className={`font-bold text-sm ${ratingColor}`}>{reviews.rating}</span>
          <span className={`text-[11px] font-medium hidden sm:inline ${countColor}`}>{reviews.count}</span>
          <span className={`text-[10px] hidden lg:inline ${googleColor}`}>| {reviews.google}</span>
        </div>
      )}
    </a>
  );
};

export default GoogleReviews;
